import { render, staticRenderFns } from "./GoodsRecordImport.vue?vue&type=template&id=2b0a87e6&"
import script from "./GoodsRecordImport.vue?vue&type=script&lang=js&"
export * from "./GoodsRecordImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports